import { palette } from '../../palette';
import {
  ProvisioningStatus,
  ExternalAccountStatus,
  EwsValidationStatus,
  StatusMap,
  VendorStatus,
  OnboardingDisplayStatus,
  DashboardApprovalStatus,
  AutoSweepTransactionStatus,
} from '../../types';

export const ProvisioningStatusMap: StatusMap<ProvisioningStatus> = {
  NotStarted: { color: palette.warning.main, label: 'Not Started' },
  InProgress: { color: palette.warning.main, label: 'In Progress' },
  Error: { color: palette.error.main, label: 'Error' },
  CriticalError: { color: palette.error.main, label: 'Critical Error' },
  Completed: { color: palette.success.main, label: 'Completed' },
};

export const ExternalAccountStatusMap: StatusMap<ExternalAccountStatus> = {
  INACTIVE: { color: palette.warning.main, label: 'Inactive' },
  PENDING_VERIFICATION: { color: palette.warning.main, label: 'Pending Verification' },
  ACTIVE: { color: palette.success.main, label: 'Active' },
  BLOCKED: { color: palette.warning.main, label: 'Blocked' },
};

export const EwsValidationStatusMap: StatusMap<EwsValidationStatus> = {
  PENDING: { color: palette.warning.main, label: 'Pending' },
  NOT_FOUND: { color: palette.error.main, label: 'Not Found' },
  CLOSED: { color: palette.error.main, label: 'Closed' },
  HIGH_RISK: { color: palette.error.main, label: 'High Risk' },
  INVALID_DEBIT_ACCOUNT: { color: palette.error.main, label: 'Invalid Debit Account' },
  OPEN: { color: palette.success.main, label: 'Open' },
  VALIDATED: { color: palette.success.main, label: 'Validated' },
};

export const VendorStatusMap: StatusMap<VendorStatus> = {
  NEW: { color: palette.info.main, label: 'New' },
  CONFIRMATION_REQUIRED_VENDOR: { color: palette.common.white, label: 'Vendor Confirmation Required' },
  CONFIRMATION_REQUIRED_ADMIN: { color: palette.warning.main, label: 'Admin Confirmation Required' },
  ACCOUNT_NUMBER_VALIDATION: { color: palette.warning.main, label: 'Account Number Validation' },
  PROVISIONING: { color: palette.warning.main, label: 'Provisioning' },
  FAILED: { color: palette.error.main, label: 'Failed' },
  ACTIVE: { color: palette.success.main, label: 'Active' },
  ARCHIVED: { color: palette.text.disabled, label: 'Archived' },
  EXISTING: { color: palette.warning.main, label: 'Already Exist' },
  EXIST_IN_VLAW: { color: palette.warning.main, label: 'Exist in VLaw' },
};

export const DashboardApprovalStatusMap: StatusMap<DashboardApprovalStatus> = {
  AWAITING_APPROVAL: { color: '#0da8c9', label: 'Awaiting Review' },
  APPROVED_PROCESSING: { color: palette.warning.main, label: 'Payment in Process' },
  APPROVED_TO_BE_PAID: { color: palette.success.main, label: 'Ready to Pay' },
  CHANGES_REQUESTED: { color: palette.error.main, label: 'Changes Requested' },
  WAITING_FOR_SUBMISSION: { color: palette.text.disabled, label: 'Waiting for Submission' },
  COMPLETED: { color: palette.success.main, label: 'Payment Completed' },
  NOT_AVAILABLE: { color: palette.text.disabled, label: 'Not Available' },
}

export const OnboardingStatusMap: StatusMap<OnboardingDisplayStatus> = {
  COMPLETED: { color: palette.success.main, label: 'Completed' },
  IN_PROGRESS: { color: palette.warning.main, label: 'In Progress' },
  BLOCKED: { color: palette.error.main, label: 'Blocked' },
  INVITE_SENT: { color: '#0da8c9', label: 'Invite Sent' },
  NOT_STARTED: { color: palette.text.primary, label: 'Not Started' },
  NOT_APPLICABLE: { color: palette.text.disabled, label: 'Not Applicable' },
}

export const AutoSweepTransactionStatusMap: StatusMap<AutoSweepTransactionStatus> = {
  Queued: { color: palette.info.main, label: 'Queued' },
  Pending: { color: palette.warning.main, label: 'Pending' },
  Processing: { color: palette.warning.main, label: 'Processing' },
  Completed: { color: palette.success.main, label: 'Completed' },
  Failed: { color: palette.error.main, label: 'Failed' },
  RetryScheduled: { color: palette.info.main, label: 'Retry Scheduled' },
  RetryFailed: { color: palette.error.main, label: 'Retry Failed' },
  Cancelled: { color: palette.text.disabled, label: 'Cancelled' },
};

export const statusOptions = [
  { id: 'all', label: 'All statuses' },
  { id: 'Completed', label: 'Completed' },
  { id: 'Failed', label: 'Failed' },
  { id: 'RetryFailed', label: 'Retry Failed' },
  { id: 'RetryScheduled', label: 'Retry Scheduled' },
  { id: 'Cancelled', label: 'Cancelled' },
  { id: 'Queued', label: 'Queued' },
  { id: 'Pending', label: 'Pending' },
  { id: 'Processing', label: 'Processing' },
];

export const timingOptions = [
  { id: 'scheduled', label: 'Weekly' },
];

export const dayOfWeekOptions = [
  { id: 'sunday', label: 'Sunday' },
  { id: 'monday', label: 'Monday' },
  { id: 'tuesday', label: 'Tuesday' },
  { id: 'wednesday', label: 'Wednesday' },
  { id: 'thursday', label: 'Thursday' },
  { id: 'friday', label: 'Friday' },
  { id: 'saturday', label: 'Saturday' },
];

export const dayOfWeekValueMap = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];


